import { render, staticRenderFns } from "./EachDistrictServingElderByGender.vue?vue&type=template&id=30d49125&scoped=true&"
import script from "./EachDistrictServingElderByGender.vue?vue&type=script&lang=js&"
export * from "./EachDistrictServingElderByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d49125",
  null
  
)

export default component.exports